import { render, staticRenderFns } from "./Terms_copy.vue?vue&type=template&id=a407ee84&"
import script from "./Terms_copy.vue?vue&type=script&lang=js&"
export * from "./Terms_copy.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/pages/pages.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports